module.exports = __webpack_public_path__ + "img/1435797498.c70b2084.jpg";